import React from 'react';
import './CtComplianceBanner.css';

export default function CtComplianceBanner() {
  return (
    <div className="ct-compliance-banner">
      <p className="ct-compliance-banner__text">
        Do not use cannabis if you are under twenty-one years of age. Keep cannabis out of the reach of children.
      </p>
    </div>
  );
}
